import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";
import { Icon, type ChipTone, type IconName } from "./Icon";

export type Tone = "neutral" | ChipTone;

export function Badge({ tone = "neutral", dot, icon, children, className, title }: {
  tone?: Tone; dot?: boolean; icon?: IconName; children: ReactNode; className?: string; title?: string;
}) {
  return (
    <span className={cx("badge", `badge-${tone}`, dot && "badge-dot", className)} title={title}>
      {icon && <Icon name={icon} size={13} />}
      {children}
    </span>
  );
}

/** Label + tone (+ optional icon) for each value of an enum, so badges and selects share wording. */
export type EnumMeta<T extends string> = Record<T, { label: string; tone?: Tone; icon?: IconName; hint?: string }>;

export function EnumBadge<T extends string>({ value, meta, dot }: { value: T; meta: EnumMeta<T>; dot?: boolean }) {
  const m = meta[value];
  return <Badge tone={m?.tone} dot={dot} icon={dot ? undefined : m?.icon}>{m?.label ?? value}</Badge>;
}
